<script lang="ts" setup>
const props = defineProps<{
  disabled?: boolean;
}>();
</script>

<template>
  <button
    class="google-pay-fake-button"
    type="button"
    :disabled="props.disabled"
  >
    <svg
      width="104"
      height="17"
      fill="none"
      viewBox="0 0 104 17"
    >
      <path
        fill="#fff"
        d="M.148 2.976h3.766q.798 0 1.477.35t1.085.966q.406.615.406 1.358 0 .742-.371 1.288t-.973.826v.084q.756.265 1.225.882.47.615.469 1.442a2.6 2.6 0 0 1-.427 1.47q-.427.644-1.148 1.001A3.5 3.5 0 0 1 4.082 13H.148zm3.696 4.2q.672 0 1.085-.42t.413-.966-.399-.959q-.4-.413-1.043-.413H1.716v2.758zm.238 4.368q.714 0 1.141-.448t.427-1.036q0-.602-.441-1.043-.44-.441-1.183-.441h-2.31v2.968zm7.36 1.68q-1.302 0-1.981-.777-.68-.777-.679-2.163V5.86h1.54v4.214q0 .869.413 1.302t1.085.434q.546 0 .966-.287t.644-.763c.15-.32.226-.669.224-1.022V5.86h1.54V13h-1.456v-.924h-.084q-.294.504-.91.826t-1.302.322m7.878-.616L16.352 5.86h1.722l2.016 4.858h.056l1.96-4.858H23.8l-4.41 10.164h-1.624zm8.266-6.748h1.666l1.442 5.11h.056l1.61-5.11h1.582l1.596 5.11h.056l1.442-5.11h1.638L36.392 13h-1.624L33.13 7.876h-.042L31.464 13h-1.596zM40.7 4.824a1 1 0 0 1-.735-.301 1 1 0 0 1-.301-.735 1 1 0 0 1 .301-.735 1 1 0 0 1 .735-.301 1 1 0 0 1 .735.301 1 1 0 0 1 .301.735 1 1 0 0 1-.301.735 1 1 0 0 1-.735.301m-.77 1.036h1.54V13h-1.54zm6.464 7.252q-.476 0-.896-.154a2 2 0 0 1-.686-.406q-.602-.601-.602-1.638V7.218h-1.246V5.86h1.246V3.844h1.54V5.86h1.736v1.358H45.75v3.36q0 .574.224.812.21.28.728.28.239 0 .42-.063.182-.063.392-.203v1.498q-.462.21-1.12.21m2.782-10.136h1.54v2.73l-.07 1.092h.07q.308-.504.917-.833.609-.33 1.309-.329 1.301 0 1.988.763.686.764.686 2.079V13h-1.54V8.688q0-.812-.427-1.218t-1.113-.406q-.518 0-.931.294c-.279.2-.503.467-.651.777-.158.32-.24.672-.238 1.029V13h-1.54zm32.619-.347v4.097h2.554q.911 0 1.509-.607a1.96 1.96 0 0 0 .613-1.442q0-.82-.613-1.427-.597-.622-1.51-.622zm0 5.539v4.753H80.27V1.186h4.045q1.542.001 2.62 1.016 1.094 1.016 1.094 2.475 0 1.492-1.094 2.49-1.062 1.001-2.62 1h-2.52zm7.775 2.294q0 .591.507.984.506.393 1.185.393.961 0 1.716-.704.754-.705.754-1.655-.714-.558-1.99-.557-.929 0-1.55.443-.622.442-.622 1.096m1.974-5.834q1.692 0 2.67.893.978.894.978 2.45v4.95h-1.459v-1.115h-.066q-.945 1.377-2.52 1.377-1.344 0-2.247-.787t-.904-1.966q0-1.246.953-1.983.954-.738 2.545-.738 1.36 0 2.238.492v-.345q0-.787-.63-1.335a2.17 2.17 0 0 0-1.475-.55q-1.277 0-2.023 1.067L88.261 6.2q1.11-1.573 3.283-1.572m12.021.262-5.09 11.57h-1.576l1.89-4.048L95.44 4.89h1.658l2.421 5.77h.033l2.355-5.77z"
      />
      <path
        fill="#4285f4"
        d="M75.631 7.143q0-.712-.117-1.37H69.08v2.596h3.684a3.12 3.12 0 0 1-1.362 2.05v1.686h2.199c1.288-1.174 2.03-2.91 2.03-4.962"
      />
      <path
        fill="#34a853"
        d="M69.08 13.733c1.842 0 3.392-.598 4.522-1.628l-2.2-1.687c-.611.408-1.4.646-2.321.646-1.78 0-3.29-1.186-3.83-2.784h-2.265v1.738a6.83 6.83 0 0 0 6.094 3.715"
      />
      <path
        fill="#fabb05"
        d="M65.251 8.28a4 4 0 0 1 0-2.58V3.961h-2.265a6.64 6.64 0 0 0-.727 3.028c0 1.089.262 2.117.727 3.028z"
      />
      <path
        fill="#e94235"
        d="M69.08 2.916c1.006 0 1.907.342 2.618 1.011l1.947-1.923C72.462.916 70.92.247 69.08.247a6.83 6.83 0 0 0-6.095 3.715L65.25 5.7c.54-1.597 2.05-2.783 3.83-2.783"
      />
    </svg>
  </button>
</template>

<style lang="scss" scoped>
.google-pay-fake-button {
  @include reset-btn;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  padding: 0 24px;
  border-radius: 999px;
  background-color: #000;

  &:disabled {
    background-color: $color-black-200;
    cursor: not-allowed;
  }
}
</style>
